import React from 'react';
import { navigate } from 'gatsby';

//CORE COMPONENTS
import { ThemeProvider } from '../../../components-core/packages/components-core/dist/theme-provider';
import styled from 'styled-components';

import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerHorizontalAlignment
} from '../../../components-core/packages/components-core/dist/container/index';
import { Text, TextAppearance, TextAlignment, TextColor } from '../../../components-core/packages/components-core/dist/text';

//CUSTOM COMPONENTS
import { Button, ButtonAppearance } from '../../../components-core/packages/components-core/dist/button';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';





const TopContainer = styled.div`
    width: 100vw;
    
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    ${props => props.inverted &&
        `
            background: rgb(0,67,122);
            background: -moz-linear-gradient(325deg, rgba(0,67,122,1) 0%, rgba(0,30,80,1) 100%);
            background: -webkit-linear-gradient(325deg, rgba(0,67,122,1) 0%, rgba(0,30,80,1) 100%);
            background: linear-gradient(325deg, rgba(0,67,122,1) 0%, rgba(0,30,80,1) 100%);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00437a",endColorstr="#001e50",GradientType=1);
        `
    }
`;


class LeadForm extends React.Component {

    renderTitle() {
        const { custom4, custom5 } = this.props;

        return (
            <Container 
                padding={padding4Dimensions} 
                horizontalAlign={ContainerHorizontalAlignment.center}
            >
                <h2><Text textAlign={TextAlignment.center} appearance={TextAppearance.headline0400}>
                    {custom4 + ' '} 
                    <Text bold appearance={TextAppearance.headline0400} >
                        {custom5}
                    </Text>
                </Text></h2>
            </Container>
        )
    }

    renderDescription() {
        const { custom1 } = this.props;

        return (
            <Container 
                padding={padding4Dimensions} 
                horizontalAlign={ContainerHorizontalAlignment.center} 
            >
                <Text textAlign={TextAlignment.center} appearance={TextAppearance.copy0200}>
                    {custom1}
                </Text>
            </Container>
        )
    }

    renderButton() {
        const { custom3, custom2 } = this.props;

        return (
            <Container 
                horizontalAlign={ContainerHorizontalAlignment.center}
                padding={{ left: globalPadding, right: globalPadding }}
            >
                <Button appearance={ButtonAppearance.Primary} onClick={() => navigate(custom2)}>
                    <Text appearance={TextAppearance.copy0150} color={TextColor.inherit}  >
                        {custom3}
                    </Text>  
                </Button>
            </Container>
        )
    }

    renderInnerContainer() {

        const mainContainerPadding = {
            top: ContainerPadding.dynamic0300,
            bottom: ContainerPadding.dynamic0300
        }

        return (
            <Container 
                padding={mainContainerPadding}
                horizontalAlign={ContainerHorizontalAlignment.center} 
            >
                <Container 
                    horizontalAlign={ContainerHorizontalAlignment.center}
                    stretchContent={true}
                    wrap={ContainerWrap.always}
                >
                    {this.renderTitle()}
                    {this.renderDescription()}
                    {this.renderButton()}
                </Container>
            </Container>
        )
    }

    render() {
        const { inverted } = this.props;

        return (
            <ThemeProvider theme={inverted ? 'inverted' : 'main'} >
                <TopContainer inverted={inverted} >
                    {this.renderInnerContainer()}
                </TopContainer>   
            </ThemeProvider>
        )
    }
}

export default LeadForm;

const globalPadding = {
    [Breakpoints.b1920]: ContainerPadding.grid007,
    [Breakpoints.b1600]: ContainerPadding.grid006,
    [Breakpoints.b1280]: ContainerPadding.grid005,
    [Breakpoints.b960]: ContainerPadding.grid004,
    [Breakpoints.default]: ContainerPadding.grid002
}

const padding4Dimensions = {
    left: globalPadding,
    right: globalPadding,
    bottom: ContainerPadding.dynamic0100
}

